export default {
  name: 'spanish',
  locale: 'es',
}
export const langDir = 'ltr'
